import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  periodConfigsLength: 0,
  periodConfigs: [],
  periodConfig: {},
  periodConfigError: "",
  formError: "",
};

export default function PeriodConfigReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_PERIOD_CONFIG:
      return { ...state, loading: action.payload };
    case actions.LOADING_PERIOD_CONFIG_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_PERIOD_CONFIG:
      return { ...state, saveLoading: action.payload };
    case actions.GET_PERIOD_CONFIG:
      return {
        ...state,
        periodConfigs: action.payload.periodConfigs,
        periodConfigsLength: action.payload.periodConfigsLength,
      };
    case actions.GET_PERIOD_CONFIG_BY_ID:
      return {
        ...state, periodConfig: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.PERIOD_CONFIG_FAIL:
      return { ...state, periodConfigError: action.payload };
    default:
      return state;
  }
}
